export default "__VITE_ASSET__dlZLiKkT__"